'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getCountryCodeFromLocale = require('./getCountryCodeFromLocale');

var _getCountryCodeFromLocale2 = _interopRequireDefault(_getCountryCodeFromLocale);

var _TelephoneData = require('I18n/constants/TelephoneData');

var TelephoneData = _interopRequireWildcard(_TelephoneData);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var INVALID_OPTION = {
  dialCode: '',
  priority: 10001,
  iso2: null
};

exports.default = function (inputNumber) {
  var allCountries = TelephoneData.allCountries;
  var allCountryCodes = TelephoneData.allCountryCodes;
  var iso2Lookup = TelephoneData.iso2Lookup;

  var bestGuess = void 0;
  var secondBestGuess = allCountries[iso2Lookup[(0, _getCountryCodeFromLocale2.default)()]] || allCountries[0];
  var inputNumberForCountries = inputNumber.substr(0, 4);
  if (inputNumber.trim() !== '') {
    var selectedCountry = INVALID_OPTION;
    allCountries.every(function (country) {
      // no country should have a dial code of more than 4 digits
      if (selectedCountry.dialCode.length === 4) {
        return false;
      }

      // if the country dialCode exists with area code (4 digits)
      if (allCountryCodes[inputNumberForCountries] && allCountryCodes[inputNumberForCountries][0] === country.iso2) {
        selectedCountry = country;
        return true;

        // if the selected country dialCode is there with the area code
      } else if (allCountryCodes[inputNumberForCountries] && allCountryCodes[inputNumberForCountries][0] === selectedCountry.iso2) {
        return true;
      }
      // else check if the input number closely matches this country
      if (inputNumber.indexOf(country.dialCode) === 0) {
        if (country.dialCode.length > selectedCountry.dialCode.length || country.dialCode.length === selectedCountry.dialCode.length && country.priority < selectedCountry.priority) {
          selectedCountry = country;
          return true;
        }
      }

      return true;
    });
    bestGuess = selectedCountry;
  } else {
    return secondBestGuess;
  }

  if (!bestGuess.name) {
    return secondBestGuess;
  }

  return bestGuess;
};

module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/I18n/static-7.270/js/utils/guessCountryFromDialCode.js
// module id = 297
// module chunks = 0